import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons"; 
import { FaBell } from "react-icons/fa";
import useUser from "../../hook/useUser.js";

const ManagerHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, loading } = useUser();
    const mockUser = { managerName: "Naoyu", photo: null };
    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
    const [managerHasUnreadNotification, setManagerHasUnreadNotification] = useState(false);

    const quizResult = user?.quizResult;
    const hasNotification = Boolean(quizResult?.updatedAt);

    // managerIdまたはmanagerNameでlocalStorageキーを分ける
    const managerKey = user?.managerId || user?.managerName || "default";
    const latestUpdateMs = useMemo(() => {
        return quizResult?.updatedAt ? new Date(quizResult.updatedAt).getTime() : 0;
    }, [quizResult]);

    useEffect(() => {
        if (!managerKey || !latestUpdateMs) {
            setManagerHasUnreadNotification(false);
            return;
        }
        const storageKey = `notification:lastSeen:manager:${managerKey}`;
        const lastSeenMs = Number(localStorage.getItem(storageKey) || 0);
        setManagerHasUnreadNotification(latestUpdateMs > lastSeenMs);
    }, [managerKey, latestUpdateMs]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleString();
    };

    const handleManagerNotificationClick = () => {
        // 既読にする
        if (managerKey && latestUpdateMs) {
            const storageKey = `notification:lastSeen:manager:${managerKey}`;
            localStorage.setItem(storageKey, String(latestUpdateMs));
        }
        setManagerHasUnreadNotification(false);
        setIsNotificationModalOpen(true);
    };

    const handleCloseNotificationModal = () => {
        setIsNotificationModalOpen(false);
    };

    const getTitle = () => {
        if (location.pathname === "/manager/profile") return "Your Profile";
        if (location.pathname === "/manager/profile/setting") return "Your Profile";
        if (location.pathname === "/manager/profile/change-password") return "Your Profile";
        if (location.pathname === "/manager/feedback-employee-list") return "Update Feedback";
        if (location.pathname === "/manager/feedback/:employeeId/quizzes") return "Update Feedback";
        if (location.pathname === "/manager/dashboard/lessons/upload") return "Upload Lessons";
        if (location.pathname === "/manager/dashboard/lessons/assign") return "Assign Lessons";
        if (location.pathname === "/manager/dashboard/lessons/assign/positions") return "Assign Lessons";
        if (location.pathname === "/manager/dashboard/lessons/library") return "Library";
        if (location.pathname === "/manager/dashboard/empID-create") return "ID Management";
        if (location.pathname === "/manager/dashboard/empID-delete") return "ID Management";
        return `Welcome, ${mockUser.managerName}`;
    };

    return (
        <>
            <div className="manager-dashboard-inner manager-header">
                <div className="header-left">
                    <h1 className="dashboard-h1">
                        {getTitle()}
                    </h1>
                </div>
                <div className="header-right">
                    <button type="button" className="manager-header-notification-wrapper"
                        size={30} onClick={handleManagerNotificationClick}
                        style={{ cursor: "pointer" }}>
                    <FaBell className="header-profile-icon"/>
                    {managerHasUnreadNotification &&
                            <span className="header-notification-dot" />}
                    </button>
                    <FontAwesomeIcon icon={faUser}
                        className="header-profile-icon"
                        onClick={() => navigate("/manager/profile")}
                        style={{ cursor: "pointer" }}
                        size={50}
                    />
                </div>
            </div>

            {isNotificationModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                    }}
                    onClick={handleCloseNotificationModal}
                >
                    <div
                        style={{
                            position: "relative",
                            width: "420px",
                            maxWidth: "90vw",
                            backgroundColor: "#FFFDF6",
                            borderRadius: "8px",
                            border: "1px solid #471111",
                            padding: "20px",
                            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
                        }}
                        onClick={(event) => event.stopPropagation()}
                    >
                        <button 
                            className="employee-feedback-close" 
                            onClick={handleCloseNotificationModal} 
                            aria-label="Close Notification"
                            style={{
                                position: "absolute",
                                top: "12px",
                                right: "12px",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "0",
                            }}
                        >
                            <img src="/images/close-window-dark.png" alt="close" />
                        </button>

                        <h2 style={{ marginTop: 0, color: "#471111" }}>Notification</h2>

                        {!loading && hasNotification && (
                            <div className="notification-box">
                                <p className="notification-main">
                                <strong>Score updated:</strong> {user.employeeName}'s score for {quizResult.quizTitle} has been updated
                                </p>
                                <p className="notification-date">{formatDate(quizResult.updatedAt)}</p>
                            </div>
                        )}
                        {!loading && !hasNotification && (
                            <div style={{ border: "1px solid #471111", borderRadius: "8px", padding: "12px", color: "#471111" }}>
                                No notifications yet.
                            </div>
                        )}
                        {/* <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
                            <button type="button" onClick={handleCloseNotificationModal}>Close</button>
                        </div> */}
                    </div>
                </div>
            )}
        </>
    );
};

export default ManagerHeader;